var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container uk-container-expand"},[_c('div',{staticClass:"uk-grid uk-child-width-1-1 uk-grid-small"},[_c('div',[_c('builder')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }